<div id="chooseSection" *ngIf="taskMode == 'choose'">
  <div class="row">
    <div class="col-12">
      Task not found.  Please choose how you would like to proceed.
    </div>
  </div>
  <div class="row my-3">
    <div class="col-12 text-center py-3">


      <button class="btn btn-sm btn-dark me-2" (click)="addNewTask()">Create New Task</button>
      <button class="btn btn-sm btn-dark me-2" (click)="hideTaskModal()">Use Existing Task</button>
    </div>
  </div>
</div>
<div id="addSection" *ngIf="taskMode == 'add'">
  <div class="row mb-2">
    <div class="col-12 col-md-2 c_blue">Task Name / Status</div>
    <div class="col-12 col-md-8">
      <input type="text" class="form-control form-control-sm" id="txt_taskname" [(ngModel)]="taskForm.taskName" placeholder="Task Name" />
    </div>
    <div class="col-12 col-md-2 pt-2">
      <input type="checkbox" id="cb_taskactive" [(ngModel)]="taskForm.taskActive" class="me-1" />
      <label for="cb_taskactive">Active</label>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-12 col-md-2 c_blue">Description</div>
    <div class="col-12 col-md-10">
      <textarea class="form-control form-control-sm" id="txt_taskdescription" [(ngModel)]="taskForm.taskDescription" placeholder="Task Description" rows="2"></textarea>
    </div>
  </div>

  <div class="row mb-2">
    <!-- Category Select -->
    <div class="col-12 col-md-4">
      <div class="row my-1">
        <div class="col-12 col-md-6">
          <label class="my-2 c_blue"><i class="fas fa-fw fa-id-card me-2"></i>Category</label>
        </div>
        <div class="col-12 col-md-6 text-end">
        </div>
      </div>
      <select size="16" id="sel_taskcategories" [(ngModel)]="taskForm.category" class="form-select form-select-sm">
        <!--<option value="">-- Select Clients --</option>-->
        <option *ngFor="let category of listCategories" [ngValue]="category.id">{{ category.c_name }}</option>
      </select>
    </div>

    <!-- Clients Select -->
    <div class="col-12 col-md-4">
      <div class="row my-1">
        <div class="col-12 col-md-6">
          <label class="my-2 c_blue"><i class="fas fa-fw fa-users me-2"></i>Clients</label>
        </div>
        <div class="col-12 col-md-6 text-end">
          <button class="btn btn-sm btn-light me-1" title="Select All" (click)="selectAll('clients')">
            <i class="fas fa-fw fa-check-double"></i>
          </button>
          <button class="btn btn-sm btn-light" title="Clear" (click)="clearAll('clients')">
            <i class="fas fa-fw fa-times"></i>
          </button>
        </div>
      </div>
      <select multiple size="16" id="sel_taskclients" [(ngModel)]="taskForm.clients" class="form-select form-select-sm">
        <!--<option value="">-- Select Clients --</option>-->
        <option *ngFor="let client of listClients; trackBy: trackClients" [ngValue]="client.id">{{ client.f_name }} {{ client.l_name }}</option>
      </select>
    </div>

    <!-- Assignees Select (Multiple) -->
    <div class="col-12 col-md-4">
      <div class="row my-1">
        <div class="col-12 col-md-6">
          <label class="my-2 c_blue"><i class="fas fa-fw fa-tags me-2"></i>Assignees</label>
        </div>
        <div class="col-12 col-md-6 text-end">
          <button class="btn btn-sm btn-light me-1" title="Select All" (click)="selectAll('assignees')">
            <i class="fas fa-fw fa-check-double"></i>
          </button>
          <button class="btn btn-sm btn-light" title="Clear" (click)="clearAll('assignees')">
            <i class="fas fa-fw fa-times"></i>
          </button>
        </div>
      </div>
      <select multiple size="16" id="sel_taskassignees" class="form-select form-select-sm" [(ngModel)]="taskForm.assignees">
        <!--<option value="">-- Select Assignees --</option>-->
        <option *ngFor="let assignee of listAssignees; trackBy: trackAssignees" [ngValue]="assignee">
          {{ assignee.display_name }}
        </option>
      </select>
      <!--<pre>{{ taskForm.assignees | json }}</pre>-->
    </div>
  </div>
  <div class="row my-1">
    <div class="col-12 col-md-4">
      <div class="alert alert-sm alert-info p-2 text-center bolder">
        <i class="fas fa-fw fa-lg fa-info-circle me-1"></i>Select One
      </div>
    </div>
    <div class="col-12 col-md-8">
      <div class="alert alert-sm alert-info p-2 text-center bolder">
        <i class="fas fa-fw fa-lg fa-info-circle me-1"></i>CTRL+Click to Select Multiple
      </div>
    </div>
  </div>
  <div class="row my-1" *ngIf="errorMessage != ''">
    <div class="col-12 text-center">
      <div class="alert alert-danger" id="task_error">{{errorMessage}}</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-sm btn-dark m-1" title="Save Task" (click)="saveTask()">
        <i class="fas fa-fw fa-save me-1"></i>Save Task
      </button>
      <button type="button" class="btn btn-sm btn-light m-1" title="Clear Task" (click)="clearTask()">
        <i class="fas fa-fw fa-arrow-rotate-left me-1"></i>Clear Task
      </button>
    </div>
  </div>
</div>
